import type { CanonicalPresentationModelV1, CanonicalPrimaryAction } from "@enrein/shared-contracts";
import { V10Btn } from "./V10Primitives.js";

const CONDITION_LABEL: Record<CanonicalPresentationModelV1["condition"], string> = {
  READY: "Ready",
  WAITING: "Waiting",
  IN_PROGRESS: "In progress",
  NEEDS_ATTENTION: "Needs attention",
  COMPLETE: "Complete",
};

export function V10StartHereCard({
  model,
  onPrimaryAction,
}: {
  readonly model: CanonicalPresentationModelV1;
  readonly onPrimaryAction: (action: CanonicalPrimaryAction) => void;
}) {
  const primary = model.primaryAction;

  return (
    <section className="v10-start-here" aria-labelledby="v10-start-here-heading">
      <p className="v10-start-here__eyebrow">Start Here</p>
      <p className="v10-start-here__stage">{model.journeyStage}</p>
      <h2 id="v10-start-here-heading" className="v10-start-here__title">
        {model.title}
      </h2>
      <p className="v10-start-here__status" role="status">{CONDITION_LABEL[model.condition]}</p>
      {model.progress ? (
        <p className="v10-start-here__progress">{model.progress.label}</p>
      ) : null}
      <p className="v10-start-here__reason">{model.reason}</p>
      {model.expectedResult ? (
        <p className="v10-start-here__expected">{model.expectedResult}</p>
      ) : null}
      {model.relevantRecords.length > 0 ? (
        <ul className="v10-start-here__records">
          {model.relevantRecords.map((record) => (
            <li key={record}>{record}</li>
          ))}
        </ul>
      ) : null}
      {primary ? (
        <div className="v10-start-here__actions">
          <V10Btn variant="primary" onClick={() => onPrimaryAction(primary)}>
            {primary.label}
          </V10Btn>
        </div>
      ) : null}
    </section>
  );
}
